export var ICONS;
(function(ICONS) {
    ICONS["ICO_TTOO"] = 'suitcase';
    ICONS["ICO_FLIGHT_HOTEL"] = 'plane-hotel';
    ICONS["ICO_FERRY_HOTEL"] = 'ferry-hotel';
    ICONS["ICO_TRAIN_HOTEL"] = 'train-hotel';
    ICONS["ICO_BUS_HOTEL"] = 'bus-hotel';
    ICONS["ICO_LEI"] = 'hot-air-balloon';
    ICONS["ICO_SKI"] = 'snow';
    ICONS["ICO_DIS"] = 'disney';
    ICONS["ICO_GV_CIR"] = 'earth-arrow';
    ICONS["ICO_GV_COMB"] = 'map-markers';
    ICONS["ICO_GV_RUT"] = 'car-routes';
    ICONS["ICO_GV_TER"] = 'marker-compass';
    ICONS["ICO_FLIGHT"] = 'flight';
    ICONS["ICO_BUS"] = 'bus';
    ICONS["ICO_PLANE"] = 'plane';
    ICONS["ICO_TRAIN"] = 'train';
    ICONS["ICO_FERRY"] = 'ferry';
    ICONS["ICO_HOTEL"] = 'hotel';
    ICONS["ICO_STAR"] = 'star-filled';
    ICONS["ICO_KEY"] = 'key';
    ICONS["ICO_SAFE"] = 'check-shield';
    ICONS["ICO_REVIEW"] = 'thumbs-up-filled';
    ICONS["ICO_MAGNIFIER"] = 'magnifier';
})(ICONS || (ICONS = {}));
export const MAX_UPSIDE = 2;
export const MAX_ICON_FOOTER = 3;
export const REPLACE_DESTINATION = '#destination#';
export const ImageResize = {
    HEADER: {
        resize: {
            width: 400,
            height: 205
        },
        alternative: '/comun/images/not-available.png',
        isLazy: true
    },
    COMPANY: {
        resize: {
            width: 100,
            height: 60
        },
        alternative: '/comun/images/not-available.png'
    },
    MOBILE: {
        resize: {
            width: 240,
            height: 240,
            quality: 90
        },
        alternative: '/comun/images/not-available.png',
        isLazy: true
    },
    MOBILE_COMPANY: {
        resize: {
            width: 100,
            height: 30
        },
        alternative: '/comun/images/not-available.png',
        isLazy: true
    },
    COMPANY_MODAL: {
        resize: {
            width: 80,
            height: 30,
            suboperation: null
        },
        alternative: '/comun/images/not-available.png'
    },
    COMPANY_NEWCARD: {
        resize: {
            width: 20,
            height: 20,
            suboperation: null
        }
    },
    MODAL: {
        resize: {
            width: 425,
            height: 210
        },
        alternative: '/comun/images/not-available.png',
        isLazy: true
    },
    MODAL_LARGE: {
        resize: {
            width: 500,
            height: 700
        },
        alternative: '/comun/images/not-available.png',
        isLazy: true
    },
    TRANSPORT: {
        resize: {
            width: 30,
            height: 30
        },
        alternative: '/comun/images/not-avaiable.png'
    }
};

//# sourceMappingURL=constants.js.map